module.exports = __webpack_public_path__ + "7daceaa396452f700094f5eb21de8261.jpg";